<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="32"
    height="32"
    viewBox="0 0 32 32"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M4 16.0003C4 15.2639 4.59695 14.667 5.33333 14.667H26.6667C27.403 14.667 28 15.2639 28 16.0003C28 16.7367 27.403 17.3337 26.6667 17.3337H5.33333C4.59695 17.3337 4 16.7367 4 16.0003Z"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M4 8.00033C4 7.26395 4.59695 6.66699 5.33333 6.66699H26.6667C27.403 6.66699 28 7.26395 28 8.00033C28 8.73671 27.403 9.33366 26.6667 9.33366H5.33333C4.59695 9.33366 4 8.73671 4 8.00033Z"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M4 24.0003C4 23.2639 4.59695 22.667 5.33333 22.667H26.6667C27.403 22.667 28 23.2639 28 24.0003C28 24.7367 27.403 25.3337 26.6667 25.3337H5.33333C4.59695 25.3337 4 24.7367 4 24.0003Z"
    />
  </svg>
</template>
